import isEmpty from './isEmpty';
import {buildJourneyFromStepIds} from "../pages/Journey/JourneyFlowItems";

function getStepsStatus(questData, questID) {
  const journeyFlow = buildJourneyFromStepIds(questData.journeyStepIds);
  const questFlow = journeyFlow[questID];
  const questsFieldsAreCompleted = questData.progress.flowState[questID];
  return questFlow.steps.map((stepFlow, index) => {
    const stepItemIsMandatoryFieldsFilled = stepFlow.stepItems.map((stepItem) => {
      if (!stepItem.mandatory) return true;
      const value = questData.journeyProps[stepItem.state];
      if (typeof value === 'boolean') {
        return value === true;
      }
      return !isEmpty(value);
    });
    const stepProgress = (questsFieldsAreCompleted && questsFieldsAreCompleted[index]) || {};
    const isCompleted = !!stepProgress.isCompleted;
    const areAllMandatoryFieldsCompleted = !stepItemIsMandatoryFieldsFilled.includes(false);
    return {isCompleted, isMandatory: areAllMandatoryFieldsCompleted};
  });
}

export default getStepsStatus;
